// extracted by mini-css-extract-plugin
export const mobileLink__base = "mobileMenu-module--mobileLink__base--2zyqO";
export const mobileLink__sublink = "mobileMenu-module--mobileLink__sublink--2GPbm";
export const mobileMenu = "mobileMenu-module--mobileMenu--2CQ9R";
export const mobileLink__active = "mobileMenu-module--mobileLink__active--Hx9al";
export const closeIcon = "mobileMenu-module--closeIcon--1Nh9k";